export default __webpack_public_path__ + "static/media/fusecash.6e376022.png";